module.exports = __webpack_public_path__ + "static/img/枪.1a17c24.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wuqi/枪.png
// module id = ThQb
// module chunks = 3